import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  padding-top: 12px;
`

export const TargetName = styled.div`
  flex-shrink: 1;
  justify-content: flex-start;
`

export const MultiTarget = styled.div`
  flex: 1;
  justify-content: center;
  text-align: center;
  padding: 0 8px;
`

export const ActionIcons = styled.div`
  flex-shrink: 1;
  padding: 0 4px;
`

export const LastChecked = styled.div`
  flex-shrink: 1;
  justify-content: flex-end;
`

export const icon = css`
  margin-right: 4px;
  cursor: pointer;
`
